
<template>
    <div style="margin-top: 20px;">

        <div style="text-align: center; width: 100px;background: #2f2d2d; padding: 10px; color: #fff; border-radius: 0px 26px 26px 0px;margin-bottom: 20px;">{{ depName }}</div>
        <div style="display: flex; width: 100%;overflow-x: auto;">
            <div style="border: 1px solid #ccc ;padding: 10px 30px; border-radius: 5px; white-space: nowrap;" :style="{
                         color: dataListIndex === index ? '#fff' : '',
                         background: dataListIndex === index ? '#1683dc' : '',
                }"
                v-for="(itme,index) in dataList" :key="index" @click="handleClickitme(index,itme.userId)">{{ itme.teacherName }}</div>
        </div>

        <div style="display: flex;padding-top: 10px;" v-if="dataList">

            <div  style="width: 45%;">
                <el-calendar v-model="selectedDate" ref="refselectedDate">
                    <template  slot="dateCell" slot-scope="{date, data}">
                        <span style="display: none;">{{ date }}</span>
                        <div  @click="handleDateClick(data)" style="width: 100%;display: flex;height: 100%;flex-wrap: wrap;">
                            <p :class="data.isSelected ? 'is-selected' : ''"> {{ data.day.split('-').slice(1).join('-') }}</p>
                            <img style="height: 40px; margin-top: -10px;" src="./hhhh.gif" alt="Happy" v-if="data.isSelected">
                        </div>
                        <div  @click="handleDateClick(data)"  v-for="(itme, index) in dayTime" :key="index" style="display: flex;justify-content: center;width: 100%;margin-top: -18px;">
                            <div v-if="( data.day === itme.time && itme.state === 1) && !data.isSelected " class="yellowbudge"></div>
                            <div v-if="( data.day === itme.time && itme.state === 2) && !data.isSelected " class="redbudge"></div>
                            <div v-if="( data.day === itme.time && itme.state === 3) && !data.isSelected " class="bluebudge"></div>
                            <!-- <div v-if="( data.day === itme.time && itme.state === 0) && !data.isSelected " class="purplebudge"></div> -->
                        </div>
                    </template>
                </el-calendar>
            </div>

            <div style="width: 25%;padding-top: 20px;">
                <div style="display: flex;width: 80%; justify-content: space-between;margin-bottom: 5px;">
                    <div>上班时间 10:00 </div>
                    <div style="padding: 0px 10px; background: #bab6b6;border-radius: 10px;">弹性30分钟</div>
                </div>
                <div style="color: #fff;  width: 80%; padding: 10px;border-radius: 10px;margin-bottom: 30px;" :style="{ background: inIsShowBg   }">
                    <div v-if="inIsShowBg === '#1683dc'">已打卡 {{ this.IndatTimes }} </div>
                    <div v-if="inIsShowBg === '#e6a23c'">迟到卡 {{ this.IndatTimes }} </div>
                    <div v-if="inIsShowBg === '#cf111d'">未打卡 缺卡</div>
                    <!-- <div v-if="isShowBg === '#8f11de'">请假</div> -->
                    <div v-if="inIsShowBg === '#1683dc' || inIsShowBg === '#e6a23c'">{{ inDatPlace }}</div>
                </div>
                <div style="display: flex;width: 80%; justify-content: space-between;margin-bottom: 5px;">
                    <div>下班时间 19:00 </div>
                    <div style="padding: 0px 10px; background: #bab6b6;border-radius: 10px;">弹性30分钟</div>
                </div>
                <div style="color: #fff;  width: 80%; padding: 10px;border-radius: 10px;" :style="{ background: OutIsShowBg }">
                    <div v-if="OutIsShowBg === '#1683dc'">已打卡 {{ outDatTimes }} </div>
                    <div v-if="OutIsShowBg === '#e6a23c'">早退卡 {{ outDatTimes }} </div>
                    <div v-if="OutIsShowBg === '#cf111d'">未打卡 缺卡</div>
                    <div v-if="OutIsShowBg === '#8f11de'">请假</div>
                    <div v-if="OutIsShowBg === '#1683dc' || OutIsShowBg === '#e6a23c'">{{ outDatPlace }}</div>
                </div>
            </div>


            <div style="width: 30%; height: 350px; border: 1px solid #ccc; border-radius: 10px;">
                <div style="display: flex;justify-content: space-between; padding: 10px; font-size: 15px;">
                    <div>出勤天数:</div>
                    <div>{{ this.ClockrResultList.Normal  }}天</div>
                </div>
                <div style="display: flex;justify-content: space-between; padding: 10px; font-size: 15px;">
                    <div>迟到:</div>
                    <div>{{ this.ClockrResultList.Late }}次</div>
                </div>
                <!-- <div style="display: flex;justify-content: space-between; padding: 10px; font-size: 15px;">
                    <div>严重迟到:</div>
                    <div>{{this.ClockrResultList.}}次, 共0分钟</div>
                </div> -->
                <div style="display: flex;justify-content: space-between; padding: 10px; font-size: 15px;">
                    <div>早退:</div>
                    <div>{{this.ClockrResultList.Early}}次</div>
                </div>
                <div style="display: flex;justify-content: space-between; padding: 10px; font-size: 15px;">
                    <div>缺卡:</div>
                    <div>{{this.ClockrResultList.Lack}}次</div>
                </div>
                <div style="display: flex;justify-content: space-between; padding: 10px; font-size: 15px;">
                    <div>外出:</div>
                    <div>{{this.ClockrResultList.GoOut}}次</div>
                </div>
                <div style="display: flex;justify-content: space-between; padding: 10px; font-size: 15px;">
                    <div>换班:</div>
                    <div>{{this.ClockrResultList.ShiftChange }}次</div>
                </div>
                <div style="display: flex;justify-content: space-between; padding: 10px; font-size: 15px;">
                    <div>外勤:</div>
                    <div>{{ this.ClockrResultList.FieldPunch }}次</div>
                </div>
                <div style="display: flex;justify-content: space-between; padding: 10px; font-size: 15px;">
                    <div>请假:</div>
                    <div>{{ this.ClockrResultList.Leave }}次</div>
                </div>
            </div>


        </div>
        <div v-else>
            <el-empty description="哈哈哈哈没人"></el-empty>
        </div>


    </div>
</template>

 <script>

 import axios from "axios";
 import apiBaseUrl from "../../../config/api";
 import loadingUtils from "../../utils/loading";
 import { put, signatureUrl, getFileNameUUID } from "../../utils/oss";
 import { Guci } from './brothersEvent.js';
 import{getCheckInResultsByUserIdAPI,getPersonCheckResultsAPI, getCheckInResultAPI } from '@/api/Attendance.js'

 export default {
     props:{
        depName:{
             default:'', type:String
        },
        dataList:{
            default:[],
            type: Array
        },
        // dayTime:{
        //     default:[],
        //     type: Array
        // },
     },
     data() {
       return {
            dataListIndex: 0,
            selectedDate: new Date(),
            OutIsShowBg: '#1683dc',
            inIsShowBg: '#1683dc',
            clockList:[],
            ClockrResultList:{},
            dayDepList:[],


            UserID:'',
            dayTime:[],
            yearMonthTimes:'',
            daySwipeList:{},
            IndatTimes:'',
            outDatTimes:'',
            inDatPlace:'',
            outDatPlace:'',
            currentYearMonthDays:'',
            targetDatenNew:'',
        }
     },
     mounted() {
        Guci.$on('GuciBrothers', (boom) => {
            this.handleCalendarChange(boom)
        })


     },
     watch: {
        dataList: function(newVal, oldVal) {
            if(newVal){
                this.getCheckInResultsByUserId(newVal[0].userId)
                this.UserID = newVal[0].userId
                this.getPersonCheckResults(newVal[0].userId)
                const currentDate = new Date();
                const year = currentDate.getFullYear();
                const month = currentDate.getMonth() + 1;
                const day = currentDate.getDate();
                let currentYearMonthDay= `${year}${(month < 10 ? '0' : '') + month}${(day < 10 ? '0' : '') + day}`;
                this.currentYearMonthDays = currentYearMonthDay

                this.handleGetgetCheckInResult(newVal[0].userId,currentYearMonthDay)
            }
        },
        // dayTime: function(newVal, oldVal) {
        //     if(newVal){
        //         const currentDate1 = new Date();
        //         const year1 = currentDate1.getFullYear();
        //         const month1 = currentDate1.getMonth() + 1;
        //         let currentYearMonth = ''
        //         currentYearMonth = year1 + (month1 < 10 ? '0' : '') + month1;

        //         this.handleGetgetCheckInResult(this.UserID, currentYearMonthDay)
        //         this.getPersonCheckResults(this.UserID, currentYearMonth)
        //     }
        // },
    },

     methods:{

        handleGetgetCheckInResult(id, currentYearMonthDay){
            const data = {  userId:id,  day: currentYearMonthDay,  }
            getCheckInResultAPI(data).then((res)=>{
                if(res.code === 200){
                    let data = res.data
                    this.daySwipeList = data

                    if( data && data.records[0].checkInResult  === 'Late' ){
                        this.inIsShowBg = '#e6a23c'
                        this.IndatTimes = this.daySwipeList.records[0].checkInShiftTimeDate.substring(11, 16)
                        this.inDatPlace = this.daySwipeList.records[0].checkInRecord.locationName

                    }
                    else if( data && data.records[0].checkInResult  === 'Normal'){
                        this.inIsShowBg = '#1683dc'
                        this.IndatTimes = this.daySwipeList.records[0].checkInShiftTimeDate.substring(11, 16)
                        this.inDatPlace = this.daySwipeList.records[0].checkInRecord.locationName
                    }
                    else {
                        this.inIsShowBg = '#cf111d'

                    }


                    if( data && data.records[0].checkOutResult  === 'Late'){
                        this.OutIsShowBg = '#e6a23c'
                        this.outDatTimes = this.daySwipeList.records[0].checkOutShiftTimeDate.substring(11, 16)

                        this.outDatPlace = this.daySwipeList.records[0].checkOutRecord.locationName

                    }
                    else if( data &&  data.records[0].checkOutResult  === 'Normal'){
                        this.OutIsShowBg = '#1683dc'
                        this.outDatTimes = this.daySwipeList.records[0].checkOutShiftTimeDate.substring(11, 16)

                        this.outDatPlace = this.daySwipeList.records[0].checkOutRecord.locationName
                    }
                    else {
                        this.OutIsShowBg = '#cf111d'

                    }

                }
            })  
        },

        handleDateClick(e){
            console.log('e: ', e);
            let formattedDay = e.day.replace(/-/g, '');
            this.handleGetgetCheckInResult(this.UserID,formattedDay)
        },


        handleconvertToDate(date) {
            const year = date.substring(0, 4);

            const months = date.substring(4, 6);

            const day = date.substring(6, 8);

            const dateFormat = `${ year }-${ months}-${ day }`
            return dateFormat
        },

        handleClickitme(index,id){
            this.dataListIndex = index
            this.UserID = id

            let date = new Date();
            let years = date.getFullYear()
            let months = date.getMonth() + 1
            let yearMonth = `${ years }${ months >= 10 ? months : '0' + months }`


            this.getCheckInResultsByUserId(id, this.yearMonthTimes ? this.yearMonthTimes : yearMonth )
            this.getPersonCheckResults(id, this.yearMonthTimes ? this.yearMonthTimes : yearMonth)


            const currentDate1 = new Date()
            const year1 = currentDate1.getFullYear()
            const mont1 = currentDate1.getMonth() + 1
            const day1 = currentDate1.getDate()
            let currentYearMonthDay = `${ year1 }${ ( mont1 < 10 ? '0' : '' ) + mont1 }${ (day1 < 10 ? '0' : '') + day1 }`
            this.handleGetgetCheckInResult(id, this.currentYearMonthDays ? this.currentYearMonthDays : currentYearMonthDay )


            const currentDate = new Date();
            const day = currentDate.getDate();
            this.selectedDate = this.handleconvertToDate( this.yearMonthTimes  ? this.yearMonthTimes + '' + day : yearMonth + '' + day)


        },

        handleCalendarChange(init){
            let [year,month] = this.handleToString(init)
            let currentDate1 = new Date()
            let day1 = currentDate1.getDate()
            let targetDate = new Date(year, month + 1, 1);
            let newDates = `${ year }-${ month  >= 10 ? month + 1 : '0' + (month + 1) }-${ day1 >= 10 ? day1 : '0' + day1 }`

            this.selectedDate = newDates;

            let date = new Date(targetDate);
            let years = date.getFullYear();
            let months = (date.getMonth()).toString().padStart(2, '0'); 
            console.log('months: ', months );
            let yearMonth = `${years}${months}`;

            this.yearMonthTimes = yearMonth
            this.getCheckInResultsByUserId(this.UserID, yearMonth)
            this.getPersonCheckResults(this.UserID, yearMonth)


        },

        handleToString(dateString){
            let year = dateString.slice(0, 4)
            let month = dateString.slice(5)
            let monthMap = { "一月": 1, "二月": 2,  "三月": 3,  "四月": 4,  "五月": 5,  "六月": 6,  "七月": 7, "八月": 8,  "九月": 9,  "十月": 10,  "十一月": 11, "十二月": 12 }
            let monthNumber = monthMap[month]
            return [ parseInt(year), monthNumber - 1 ]
        },

        getCheckInResultsByUserId(id,times){
            const currentDate = new Date();
            const year = currentDate.getFullYear();
            const month = currentDate.getMonth() + 1;
            let currentYearMonth = ''
            currentYearMonth = year + (month < 10 ? '0' : '') + month;
            const data = {
                userId:id,
                day: times || currentYearMonth,
            }
            getCheckInResultsByUserIdAPI(data).then(res=>{

                if(res.code === 200){
                    this.clockList = res.data

                    this.clockList.forEach((itme)=>{

                        itme.time = `${itme.day.substring(0, 4)}-${itme.day.substring(4, 6)}-${itme.day.substring(6, 8)}`;
                        itme.state = (itme.records[0].checkInResult  === 'Late' && itme.records[0].checkOutResult  === 'Late') ? 1 : (itme.records[0].checkInResult  === 'Normal' && itme.records[0].checkOutResult  === 'Normal') ? 3 : 2
                    })

                    this.dayTime =  this.clockList
                }else{
                    this.$message({ message: res.message,   type: "error"})
                }
              })
        },

        getPersonCheckResults(id,times){
            const currentDate = new Date();
            const year = currentDate.getFullYear();
            const month = currentDate.getMonth() + 1;
            let currentYearMonth = ''
            currentYearMonth = year + (month < 10 ? '0' : '') + month;
            const data = {
                userId:id,
                day:times || currentYearMonth,
            }
            getPersonCheckResultsAPI(data).then(res=>{
                this.ClockrResultList = res.data
            })
        }

    },


    beforeDestroy() {
        Guci.$off('GuciBrothers');
    }



 };
 </script>

 <style scoped lang="less">

    /deep/ .el-calendar__header{
        display: none;
    }

    /deep/ .is-selected {
        color: #1989FA;
    }

    /deep/ .el-calendar-day{
        display: flex;
        flex-wrap: wrap;
    }


    // .yellowbudge {
    //     width: 8px;
    //     height: 8px;
    //     background: #e6a23c;
    //     border-radius: 50%;
    //     margin: 0 auto;
    //     margin-top: 10px;
    // }

    // .redbudge {
    //     width: 8px;
    //     height: 8px;
    //     background: #cf111d;
    //     border-radius: 50%;
    //     margin: 0 auto;
    //     margin-top: 10px;
    // }

    // .bluebudge {
    //     width: 8px;
    //     height: 8px;
    //     background: #1683dc;
    //     border-radius: 50%;
    //     margin: 0 auto;
    //     margin-top: 10px;
    // }

    // .purplebudge {
    //     width: 8px;
    //     height: 8px;
    //     background: #8f11de;
    //     border-radius: 50%;
    //     margin: 0 auto;
    //     margin-top: 10px;



    // position: relative; /* 确保伪元素相对于此元素定位 */

    // }


    .no-click {
       pointer-events: none;
    }

    @keyframes wave-animation {
        0%, 100% {
            transform: translateY(0);
        }
        50% {
            transform: translateY(-20px);
        }
    }

    // @keyframes ripple-animation {
    //     0%, 100% {
    //         opacity: 1;
    //         transform: scale(1);
    //     }
    //     50% {
    //         opacity: 0.6;
    //         transform: scale(2);
    //     }
    // }

    .yellowbudge::before {
        content: '';
        display: block;
        width: 8px;
        height: 8px;
        background: #e6a23c;
        border-radius: 50%;
        animation: wave-animation 1s infinite;
        animation-timing-function: ease-in-out;
    }

    .redbudge::before {
        content: '';
        display: block;
        width: 8px;
        height: 8px;
        background: #cf111d;
        border-radius: 50%;
        animation: wave-animation 1s infinite;
        animation-timing-function: ease-in-out;
    }

    .bluebudge::before {
        content: '';
        display: block;
        width: 8px;
        height: 8px;
        background: #1683dc;
        border-radius: 50%;
        animation: wave-animation 1s infinite;
        animation-timing-function: ease-in-out;
    }

    .purplebudge::before {
        content: '';
        display: block;
        width: 8px;
        height: 8px;
        background: #8f11de;
        border-radius: 50%;
        animation: wave-animation 1s infinite;
        animation-timing-function: ease-in-out;
    }

    .initbudge::before{
        content: '';
        display: block;
        width: 8px;
        height: 8px;
        background: #1bda9b;
        border-radius: 50%;
        animation: wave-animation 1s infinite;
        animation-timing-function: ease-in-out;
    }

    // .purplebudge::before {
    //     content: '';
    //     display: block;
    //     width: 8px;
    //     height: 8px;
    //     background: #8f11de;
    //     border-radius: 50%;
    //     position: absolute;
    //     top: 50%;
    //     left: 50%;
    //     transform: translate(-50%, -50%);
    //     animation: ripple-animation 1s infinite;
    //     animation-timing-function: ease-in-out;
    // }

 </style>



// WEBPACK FOOTER //
// src/AnonymousLetterManagement/components/personnelInfo.vue